import SpriteSymbol from "../../../node_modules/svg-baker-runtime/browser-symbol.js";
import sprite from "../../../node_modules/svg-sprite-loader/runtime/browser-sprite.build.js";
var symbol = new SpriteSymbol({
  "id": "video",
  "use": "video-usage",
  "viewBox": "0 0 20 20",
  "content": "<symbol xmlns=\"http://www.w3.org/2000/svg\" viewBox=\"0 0 20 20\" id=\"video\"><path fill-rule=\"evenodd\" d=\"M10 17a7 7 0 1 0 0-14 7 7 0 0 0 0 14Zm0 1a8 8 0 1 1 0-16 8 8 0 0 1 0 16ZM8 7l5 3-5 3V7Z\" /></symbol>"
});
var result = sprite.add(symbol);
export default symbol